import React from 'react';
import { Link } from 'react-router-dom';
import LocationLandingPage from './LocationLandingPage';

const OfficeFitoutsKenya = () => (
  <LocationLandingPage
    title="Office Fit-Outs in Kenya | Workspace Interior Solutions"
    description="Techie Interiors delivers office fit-out services in Kenya, including partitions, ceilings, wall finishes, storage, and modern workspace renovation for growing teams."
    path="/office-fitouts-kenya"
    h1="Office Fit-Outs in Kenya"
    intro="From startup offices to corporate workspaces, we build practical and modern office interiors across Kenya with efficient project delivery."
    serviceType="Office interior fit-out services"
    highlights={[
      'Workspace planning for productivity and team flow',
      <>
        <Link to="/gypsum-ceiling">Ceiling</Link>, <Link to="/gypsum-ceiling">partition</Link>, lighting,
        and <Link to="/wain-scouting">wall finish</Link> integration
      </>,
      'Reception, meeting room, and private office fit-outs',
      'Flexible solutions for startups, SMEs, and established organizations',
    ]}
    faqs={[
      {
        question: 'Do you provide office fit-outs outside Nairobi?',
        answer: 'Yes. We take on office interior projects in Nairobi and selected locations across Kenya based on project scope.',
      },
      {
        question: 'Can you deliver phased renovations for active offices?',
        answer: 'Yes. We can plan phased execution to keep your business operational during renovation.',
      },
    ]}
  />
);

export default OfficeFitoutsKenya;
